import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Button, Grid, Modal, Form, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';

import {
  InputField,
  CheckboxField,
  ButtonGroupField,
  TextAreaField,
} from 'Common/SemanticWrapper';
import { ProductionRecordFieldEnum as ProdRecordFields } from 'Common/FieldEnum';
import { InputMode, PRODUCTION_PLAN_FORM_NAME } from 'Common/FormEnum';
import * as EditProductionSelectors from 'Pages/manageproduction/state/editproduction/selectors';
import { formatNumber } from 'Common/FormHelper';
import * as CommonStateSelectors from 'State/selectors';

import { UserNameField } from './CloseProductionForm';

function ProductionPlanModal(props) {
  const {
    headerTitle,
    modalProps,
    isReadOnly,
    loading,
    showCloseForm,
    updateForm,
    formValues,
    userName,
    handleSubmit,
  } = props;
  const { onClose } = modalProps;
  const onModalClose = () => {
    onClose();
    updateForm(formValues);
  };

  return (
    <Modal {...modalProps}>
      <Modal.Header className="manage-menu-modal-header">
        {`Production Plan - ${headerTitle}`}
        <Icon
          name="close"
          onClick={onModalClose}
          className="manage-menu-close"
        />
      </Modal.Header>
      <Modal.Content className="manage-menu-modal-content">
        <Form>
          <Grid padded="vertically">
            <Grid.Column width={4} className="p-t-0">
              <Grid.Row>
                <Field
                  component={InputField}
                  label="Offered Servings"
                  name={ProdRecordFields.FeedingFigureOffered}
                  maxLength={4}
                  mode={InputMode.Integer}
                  hideEmptyError
                  showOnlyTouchedError
                  disabled={isReadOnly}
                  formatOnBlur={formatNumber}
                />
              </Grid.Row>
              <Grid.Row>
                <Field
                  component={InputField}
                  label="Served Reimbursable Meals"
                  name={ProdRecordFields.ServedStudents}
                  maxLength={4}
                  mode={InputMode.Integer}
                  hideEmptyError
                  showOnlyTouchedError
                  disabled={isReadOnly}
                  formatOnBlur={formatNumber}
                />
              </Grid.Row>
              <Grid.Row>
                <Field
                  component={InputField}
                  label="Pre-K Meals"
                  name={ProdRecordFields.ServedPreK}
                  maxLength={4}
                  mode={InputMode.Integer}
                  hideEmptyError
                  showOnlyTouchedError
                  disabled={isReadOnly}
                  formatOnBlur={formatNumber}
                />
              </Grid.Row>
              <Grid.Row>
                <Field
                  component={InputField}
                  label="CN Adult Meals"
                  name={ProdRecordFields.ServedSFSAdult}
                  maxLength={4}
                  mode={InputMode.Integer}
                  hideEmptyError
                  showOnlyTouchedError
                  disabled={isReadOnly}
                  formatOnBlur={formatNumber}
                />
              </Grid.Row>
              <Grid.Row>
                <Field
                  component={InputField}
                  label="Catered Meals"
                  name={ProdRecordFields.ServedCatered}
                  maxLength={4}
                  mode={InputMode.Integer}
                  hideEmptyError
                  showOnlyTouchedError
                  disabled={isReadOnly}
                  formatOnBlur={formatNumber}
                />
              </Grid.Row>
              <Grid.Row>
                <Field
                  component={InputField}
                  label="Other Meals"
                  name={ProdRecordFields.ServedOther}
                  maxLength={4}
                  mode={InputMode.Integer}
                  hideEmptyError
                  showOnlyTouchedError
                  disabled={isReadOnly}
                  formatOnBlur={formatNumber}
                />
              </Grid.Row>
              <Grid.Row>
                <Field
                  component={InputField}
                  label="Snacks"
                  name={ProdRecordFields.ServedSnacks}
                  maxLength={4}
                  mode={InputMode.Integer}
                  hideEmptyError
                  showOnlyTouchedError
                  disabled={isReadOnly}
                  formatOnBlur={formatNumber}
                />
              </Grid.Row>
            </Grid.Column>
            <Grid.Column width={12}>
              <Grid>
                <Grid.Row columns="2">
                  <Grid.Column>
                    <Field
                      component={CheckboxField}
                      label="Offer vs Serve"
                      name={ProdRecordFields.OfferVsServe}
                      useInputLabel
                      disabled={isReadOnly}
                    />
                    <Field
                      component={InputField}
                      label="OVS Notes"
                      name={ProdRecordFields.OfferVsServeNotes}
                      hideEmptyError
                      showOnlyTouchedError
                      disabled={isReadOnly}
                      maxLength={7}
                    />
                    <Field
                      label={'Water Available'}
                      component={ButtonGroupField}
                      options={[
                        { value: true, text: 'Yes' },
                        { value: false, text: 'No' },
                      ]}
                      name={ProdRecordFields.IsWaterAvailable}
                      fluid
                      disabled={isReadOnly}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Field
                      component={CheckboxField}
                      label="Healthy Employees"
                      name={ProdRecordFields.PersonnelHealthy}
                      useInputLabel
                      disabled={isReadOnly}
                    />
                    <Field
                      component={CheckboxField}
                      label="Clean Employee Appearance"
                      name={ProdRecordFields.PersonnelCleanAppearance}
                      useInputLabel
                      disabled={isReadOnly}
                    />
                    <Field
                      component={CheckboxField}
                      label="Proper Handwashing"
                      name={ProdRecordFields.PersonnelWashingHands}
                      useInputLabel
                      disabled={isReadOnly}
                    />
                    <Field
                      component={CheckboxField}
                      label="No Bare hand Contact for RTE Food"
                      name={ProdRecordFields.PersonnelNoBareHandContact}
                      useInputLabel
                      disabled={isReadOnly}
                    />
                    <Field
                      component={CheckboxField}
                      label="Thermometers checked and calibrated if needed"
                      name={ProdRecordFields.PersonnelThermometersChecked}
                      useInputLabel
                      disabled={isReadOnly}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns="1">
                  <Grid.Column>
                    <Field
                      label={'Corrective Action'}
                      component={TextAreaField}
                      name={ProdRecordFields.PersonnelNotes}
                      disabled={isReadOnly}
                      maxLength={200}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid>
          {showCloseForm && (
            <Grid className="production-plan-close-form" padded={false}>
              <Grid.Row columns="2">
                <Grid.Column>
                  <UserNameField userName={userName} isReadOnly={isReadOnly} />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    label="Comments"
                    name={ProdRecordFields.ServedNotes}
                    component={TextAreaField}
                    disabled={isReadOnly}
                    maxLength={200}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )}
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <div className="manage-menu-header-buttons">
          <Button onClick={onModalClose} className="mnm-button-blue">
            Done
          </Button>
          {showCloseForm && (
            <Button
              onClick={handleSubmit}
              loading={loading}
              className="mnm-button-blue"
              disabled={isReadOnly || loading}
            >
              Close and Submit
            </Button>
          )}
        </div>
      </Modal.Actions>
    </Modal>
  );
}

const mapStateToProps = (state, props) => ({
  headerTitle: EditProductionSelectors.getModalTitle(state),
  loading: EditProductionSelectors.getFetchingCloseProd(state),
  formValues: EditProductionSelectors.getProdPlanFormValues(state),
  userName: CommonStateSelectors.getUserName(state),
});

const ConnectedProductionPlanModal = connect(mapStateToProps)(
  reduxForm({
    form: PRODUCTION_PLAN_FORM_NAME,
    enableReinitialize: true,
    destroyOnUnmount: false,
  })(ProductionPlanModal)
);

export { ConnectedProductionPlanModal as ProductionPlanModal };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/ProductionPlanModal.js